import { Collapse } from "antd";
import React from "react";
// import PropTypes from 'prop-types'
import {
  QMS,
  ULP,
  Compliance,
  MyDocs,
  ULPConfigFilter,
  ComplianceConfigFilter,
  QMSConfigFilter,
} from "../../../components/Project/AppConfiguration/index";

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 8 },
    lg: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 12 },
    lg: { span: 16 },
  },
  style: { marginBottom: 8 },
};

const selectAppConfig = (type, params) => {
  switch (type) {
    case "Compliance":
      return (
        <Compliance
          formItemLayout={formItemLayout}
          config={params.config}
          app_id={params.app_id}
          // this.state.projectData!==undefined?getIndexList(this.state.projectData.indexes)
          indexes={Array.isArray(params.indexes) ? params.indexes : []}
          updateValue={params.updateValue}
          validate={params.validate}
          // updateValue={(e) => console.log(e)}
        />
      );
    case "ULP":
      return (
        <ULP
          formItemLayout={formItemLayout}
          config={params.config}
          app_id={params.app_id}
          indexes={Array.isArray(params.indexes) ? params.indexes : []}
          updateValue={params.updateValue}
          validate={params.validate}
        />
      );

    case "QMS":
      return (
        <QMS
          app_id={params.app_id}
          indexes={Array.isArray(params.indexes) ? params.indexes : []}
          formItemLayout={formItemLayout}
          config={params.config}
          updateValue={params.updateValue}
          validate={params.validate}
        />
      );
    case "myDocs":
      return (
        <MyDocs
          app_id={params.app_id}
          formItemLayout={formItemLayout}
          config={params.config}
          updateValue={params.updateValue}
          validate={params.validate}
        />
      );
    default:
      return null;
  }
};

function ConfigSet(props) {
  const { type, config } = props;
  // console.log(config,'config')
  const renderElm = selectAppConfig(type, props);
  return renderElm !== null ? (
    <Collapse defaultActiveKey={["1"]} expandIconPosition="end">
      <Collapse.Panel key="1" header={type}>
        {renderElm}
      </Collapse.Panel>
    </Collapse>
  ) : null;
}

// ConfigSet.propTypes = {

// }

export default ConfigSet;
